"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var PlayIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 40 40", fill: "currentColor", width: size || '40', height: size || '40' }, props),
        React.createElement("defs", null,
            React.createElement("path", { d: "M20,37.8378378 C29.8515658,37.8378378 37.8378378,29.8515658 37.8378378,20 C37.8378378,10.1484342 29.8515658,2.16216216 20,2.16216216 C10.1484342,2.16216216 2.16216216,10.1484342 2.16216216,20 C2.16216216,29.8515658 10.1484342,37.8378378 20,37.8378378 Z M20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 Z M26.594595,19.6756755 L15.1351351,12.972973 L15.1351351,26.378378 L26.594595,19.6756755 Z", id: "path-play" })),
        React.createElement("g", { id: "play-button", stroke: "none", fill: "none", strokeWidth: "1", fillRule: "evenodd" },
            React.createElement("g", { id: "Awesome-Icons---slider-+-grid", transform: "translate(-768 -876)" },
                React.createElement("g", { id: "Icons/play", transform: "translate(768 876)" },
                    React.createElement("g", { id: "play" },
                        React.createElement("mask", { id: "mask-play", fill: "currentColor" },
                            React.createElement("use", { xlinkHref: "#path-play" })),
                        React.createElement("use", { id: "Mask", fill: "currentColor", fillRule: "nonzero", xlinkHref: "#path-play" })))))));
};
PlayIcon.displayName = 'PlayIcon';
exports.default = PlayIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PlayIcon.js.map